const omniQueryKeys = {
  all: ['omni'] as const,
  search: (search: string) =>
    [...omniQueryKeys.all, 'search-by-name', search] as const,
};

export default omniQueryKeys;
